<template>
    <div class="brandparent">
        <button @click="isOpen = !isOpen" class="branddropdown pl-2 py-2 flex items-center justify-between text-sm bg-pink-200 text-pink-700 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2">
            <div class="pl-2 pr-1 text-sm">
                Select {{title}}
            </div>
            <div v-if="brand_selected.length" class="font-bold">({{brand_selected.length}})</div>
            <div class="px-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
            </div>
        </button>
        <button v-if="isOpen" @click="isOpen = false" tabindex="-1" class="fixed inset-0 h-full w-full bg-black bg-opacity-50 cursor-default"></button>
        <div v-if="isOpen" class="absolute mt-2 py-2 w-48 text-sm bg-pink-200 text-pink-800 rounded-md shadow-2xl">
            <ul>
                <li v-for="dropdown_list in dropdown_lists" :key="dropdown_list.key" @click="setBrand(dropdown_list.key)" class="flex items-center justify-between px-4 py-2 text-sm cursor-pointer hover:bg-pink-700 hover:text-pink-100">
                    <div>
                        {{dropdown_list.key}} ({{dropdown_list.doc_count}})
                    </div>
                    <div v-if="brand_selected.includes(dropdown_list.key)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "BrandDropDown",
    props: ['title', 'dropdown_lists', 'removed_brand'],
    data() {
        return {
            isOpen: false,
            brand_selected: []
        }
    },
    watch: {
        isOpen(newVal, oldVal) {
            if (newVal) {
                document.querySelector('.brandparent').classList.add("relative")
                document.querySelector('.branddropdown').classList.add("relative", "z-10")
            } else {
                document.querySelector('.brandparent').classList.remove("relative")
                document.querySelector('.branddropdown').classList.remove("relative", "z-10")
            }
        },
        removed_brand: {
            immediate: true,
            handler: function () {
                this.brand_selected = this.brand_selected.filter(item => item !== this.removed_brand)
            }
        }
    },
    methods: {
        setBrand(brand) {
            if (!this.brand_selected.includes(brand)) {
                this.brand_selected.push(brand)
                this.$emit('brand:select', brand)
            } else {
                this.brand_selected = this.brand_selected.filter(item => item !== brand)
                this.$emit('brand:remove', brand)
            }
            // this.isOpen = false
        }
    },
    created() {
        const handleEscape = (e) => {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.isOpen = false
            }
        }

        document.addEventListener('keydown', handleEscape)
    }
}
</script>